<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Carrocerias">
          <listar-carroceria />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarCarroceria from '@/components/administrativo/veiculo/carroceria/ListarCarroceria'
export default {
  data() {
    return {
      page: {
        title: 'Gerenciamento de carrocerias',
      },
      breadcrumbs: [
        {
          text: 'Gerencial',
          disabled: true,
        },
        {
          text: 'Carrocerias',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarCarroceria,
  },
}
</script>

<style></style>
